<template>
  <div :style="customStyle" class="aretv sedna-weather">
    <div class="widgetLogo">
      <img :src="`/img/are_logo.svg`" />
    </div>
    <div class="widgetTitle">
      WEATHER
    </div>
    <div class="date" v-if="weatherLocation">
       {{ formatedDate }}, {{ formatedTime }} - {{ weatherLocationLabel || weatherLocation }}
    </div>
    <div class="panels-grid" v-if="entries">
      <WeatherItem
        v-for="(item, index) in entries"
        v-bind:key="index"
        :date="item.date"
        :max="item.maxtempF"
        :min="item.mintempF"
        :desc="item.hourly"
        :code="item.hourly"
        :astro="item.astronomy"
        :style="customStyle"
      />
    </div>
    <!-- <VideoWeather class="video"/> -->
  </div>
</template>

<script>
import axios from "axios";
import WeatherItem from "./WeatherItem";
import slugify from "slugify";
// import VideoWeather from "./VideoWeather";

export default {
  name: "Weather",
  // components: { WeatherItem, VideoWeather },
  components: { WeatherItem },
  props: ["customStyle"],
  data() {
    return {
      isLoading: false,
      entries: [],
      refreshTimer: null,
      backgroundStyle: "transparent",
      playlist: [],
      error: null,
      sedna_ip: "127.0.0.1",
      weatherLocation: "",
      weatherLocationLabel: "",
      theLog: [],
      sednaPlaylist: "",
      now: new Date()
    };
  },
  computed: {
    isEmptyAndLoading() {
      return this.isLoading && this.entries.length === 0;
    },
    formatedDate() {
      let date = new Date().toLocaleDateString("en-US", {
        day: "numeric",
        month: "long"
      });
      let day = ["st", "nd", "rd", "th"];
      let currentday = new Date().getDate() > 4 ? 3 : new Date().getDate() - 1;
      return date + day[currentday];
    },
    formatedTime() {
      let time = this.now
        .toLocaleString("en-us")
        .split(",")[1]
        .split(":");
      return `${time[0]}:${time[1]} ${time[2].split(" ")[1]}`;
    }
  },
  methods: {
    getSednaPlaylist() {
      const urlQuery = new URLSearchParams(window.location.search);

      if (urlQuery.get("sedna_ip") !== null) {
        this.sedna_ip = urlQuery.get("sedna_ip");
      }
      axios
        .get(`http://${this.sedna_ip}:17236/services;playlists`)
        .then(result => {
          this.playlist = result;
        });
    },
    refreshWeather() {
      const url = "https://api.worldweatheronline.com/premium/v1/weather.ashx",
        urlQuery = new URLSearchParams(window.location.search);

      let currentLocation = "";

      if (urlQuery.get("location") !== null) {
        currentLocation = urlQuery.get("location")
      }
      if (urlQuery.get("locationLabel") !== null) {
          this.weatherLocationLabel = urlQuery.get("locationLabel")
      }
      axios
        .get(url, {
          params: {
            key: "eb498059c2164ed38dc123046191408",
            q: currentLocation,
            num_of_days: "5",
            format: "json",
            show_comments: "no",
            tp: "1"
          }
        })
        .then(result => {
          this.log("Got weather. Will call sedna playlist.");
          this.weatherLocation = result.data.data.request[0].query;
          this.entries = result.data.data.weather;
          this.current_weather =
            result.data.data.weather[0].hourly[new Date().getHours()];

          setTimeout(() => {
            if (this.current_weather) {
              const { weatherCode, weatherDesc } = this.current_weather;
              let current_video = slugify(
                `${weatherCode} ${weatherDesc[0].value}`,
                { lower: true }
              );
              this.log(`Calling sedna to play ${current_video} playlist.`);
              this.sednaPlaylist = `http://${this.sedna_ip}:17236/services;execute?command=start%20playlist%20-n%20"${current_video}"`;

              // axios
              //   .get(
              //     `http://${this.sedna_ip}:17236/services;execute?command=start%20playlist%20-n%20"${current_video}"`
              //   )
              //   .then(
              //     result => {
              //       this.log(`Sedna response status ${result.status}`);
              //       this.log(`Sedna response ${result.data}`);
              //       return result;
              //     },
              //     errResult => {
              //       this.log(`Sedna responded with error:`);
              //       this.log(errResult);
              //       this.log(`Sedna response ${errResult.data}`);
              //       this.log(`Response status: ${errResult.request.status}`);
              //       Object.keys(errResult).forEach(key => {
              //         this.log(`${key}: ${errResult[key]}`);
              //       });
              //       return result;
              //     }
              //   );
            } else {
              return false;
            }
          }, 1000);
        });
    },
    log(item) {
      this.theLog.push(item);
    }
  },
  created() {
    window.axios = axios;
    this.refreshWeather();
    // this.getSednaPlaylist();

    setInterval(() => (this.now = new Date()), 1000 * 60);

    this.refreshTimer = setInterval(this.refreshWeather, 60 * 60 * 1000); // refresh news every 30 mins
  }
};
</script>

<style>
.aretv {
  font-weight: bold;
    /* background: rgba(4,108,176,0.4)!important; */
}

@media screen and (max-width: 3839px) {
  .aretv {
    width: 1920px;
    height: 1080px;
  }
  .sedna-weather{
    padding: 120px 75px 20px 80px;
    overflow:auto;
  }
  .widgetLogo{
    line-height: 1px;
  }
  .widgetLogo img  {
    max-height: 100%;
    max-width: 100%;
    margin-left:30px;
    min-height:60px;
  }
  .widgetTitle {
    font-size: 264px;
    height: 264px;
    line-height: 265px;
    letter-spacing: 7px;
  }
  .date {
    font-size: 70px;
    height: 70px;
    line-height: 50px;
    font-weight: 600;
    margin-bottom: 150px;
    margin-left: 20px;
  }
    .panels-grid .grid-item {
    box-sizing: border-box;
    width: 310px;
    height: 340px;
    border: 1px solid;
    padding: 20px;
  }
}

@media screen and (min-width: 3840px) {
  .aretv {
    width: 3840px;
    height: 2160px;
    padding: 190px 170px 140px 170px;
  }
  .widgetLogo{
    height: 120px;
    margin-top:15px;
    margin-left:55px;
  }
  .widgetLogo img {
    height:100%;
  }
  .widgetTitle {
    font-size: 540px;
    height: 540px;
    margin-bottom: 20px;
    margin-left:20px;
    text-shadow: 10px;
    line-height: 590px;
  }
  .date {
    font-size: 140px;
    height: 140px;
    line-height: 110px;
    margin-left:20px;
    font-weight: 600;
    margin-bottom: 320px;
  }
  .panels-grid .grid-item {
    box-sizing: border-box;
    width: 625px;
    height: 685px;
    border: 1px solid;
  }
}

.debug-log {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  max-height: 100%;
  width: 100%;
  font-size: 15px;
  overflow-y: scroll;
  background-color: rgba(5, 5, 5, 0.4);
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.debug-log li {
  display: none;
  margin-bottom: 5px;
}
.sedna-playlist {
  display: none;
  width: 500px;
  height: 100px;
}
.video {
  position: fixed;
  top: 0;
  left: 0;
  z-index: -2000;
}
</style>
